import { produce } from 'immer';
import { find, groupBy, isEmpty } from 'lodash';
import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button, Space } from 'tdesign-react';

const VIEWTYPE = {
  NODE: 'node',
  HOST: 'host',
};

function SummaryList({ hostsList, steps }) {
  const [viewType, setViewType] = useState(VIEWTYPE.NODE);

  // 节点视角数据
  const fromNode = useMemo(() => {
    return produce(steps, (draft) => {
      draft.forEach((step) => {
        step.hosts = find(hostsList, { id: step.id })?.hosts;
      });
    });
  }, [hostsList, steps]);

  // 主机视角数据
  const fromHost = useMemo(() => {
    const tempHosts = [];
    fromNode.forEach((step) => {
      if (!isEmpty(step.hosts)) {
        step.hosts.forEach((host) => {
          tempHosts.push({
            ...host,
            step,
          });
        });
      }
    });

    return Object.entries(groupBy(tempHosts, 'id'));
  }, [fromNode]);

  return (
    <Root>
      <Title>清单汇总</Title>
      <Space style={{ marginBottom: 10 }}>
        <TabButton
          $unselected={viewType !== VIEWTYPE.NODE}
          theme='primary'
          variant='outline'
          onClick={() => setViewType(VIEWTYPE.NODE)}
        >
          节点视角
        </TabButton>
        <TabButton
          $unselected={viewType !== VIEWTYPE.HOST}
          theme='primary'
          variant='outline'
          onClick={() => setViewType(VIEWTYPE.HOST)}
        >
          主机视角
        </TabButton>
      </Space>
      {viewType === VIEWTYPE.NODE &&
        fromNode.map(
          (node) =>
            !isEmpty(node.hosts) && (
              <Container key={node.id}>
                <div>{node.prettyText}</div>
                {node.hosts.map((host) => (
                  <div key={host.id}>
                    {host.hostUser}@{host.serviceIp || host.hostIp}
                  </div>
                ))}
              </Container>
            ),
        )}
      {viewType === VIEWTYPE.HOST &&
        fromHost.map(([hostId, groupedStep]) => {
          const host = groupedStep[0];
          return (
            <Container key={hostId}>
              <div>
                {host.hostUser}@{host.serviceIp || host.hostIp}
              </div>
              {groupedStep.map(({ step }) => (
                <div key={step.id}>{step.prettyText}</div>
              ))}
            </Container>
          );
        })}
    </Root>
  );
}

export default connect((state) => ({
  hostsList: state.execFlow.hostsList,
  steps: state.execFlow.steps,
}))(SummaryList);

const Root = styled.div`
  width: 300px;
  padding: 16px 20px;
`;

const Title = styled.div`
  color: var(--td-text-color-primary);
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
`;

const TabButton = styled(Button)`
  ${(props) =>
    props.$unselected &&
    `
    background-color: var(--td-bg-color-component-disabled);
    border-color: #E1E1E1 !important;
    .t-button__text {
      color: rgb(32, 43, 64, .5);
    }
  `}
`;

const Container = styled.div`
  margin-bottom: 16px;
  font-size: 13px;
  line-height: 1.3;
  color: #202b40;
  padding-left: 2px;
`;
